<template>

  <div class="border border-1 rounded-3 shadow-sm">

    <div class="position-relative">
      <WatermarkImage>
        <div v-if="isEmpty(img)" class="imgSize">
          <EmptyImage :size=18></EmptyImage>
        </div>
        <div v-else>
          <img class="w-100 fit-cover imgSize rounded-top" :src="imgIsEmpty(img)">
          <div class="bg-black w-100 h-100 position-absolute top-0 opacity-5 rounded-top "></div>
          <img class="center fit-contain position-absolute rounded-0 top-0 w-100 h-100 " :src="imgIsEmpty(img)">
        </div>
      </WatermarkImage>

      <div class="position-absolute text-center  top--1">
        <object :data="$baseUrl + 'img/svg/item_tag.svg'"></object>
        <div class="position-absolute top-1 w-100 tag-color">第{{ serial_id }}項</div>
      </div>


      <div v-if="shouldShowDiscountTag(discount) && commodity_price_calc_type !== 'sell_price'" class="position-absolute text-center top--1 right--4">
        <object :data="$baseUrl + 'img/svg/discount_tag.svg'"></object>
        <div class="position-absolute top-1 w-100 font-size-12  text-white"> {{
            formatPriceCalculateType(commodity_price_calc_type)
          }}
        </div>
        <div class="position-absolute top-3 w-100 h4 font-weight-600 text-white">{{ formatDiscountDisplay(discount) }}</div>
      </div>


      <div
        v-if="shouldShowDiscountTag(combine_buy_discount) && !is_stock && is_combine_buy"
        class="position-absolute text-center right--4"
        :class="{ 'top--1': !shouldShowDiscountTag(discount) }"
        :style="shouldShowDiscountTag(discount) ? { top: '43px' } : null"
      >
        <object :data="$baseUrl + 'img/svg/combine_discount_tag.svg'"></object>
        <div class="position-absolute top-1 w-100 font-size-12  text-white">湊箱折扣</div>
        <div class="position-absolute top-3 w-100 h4 font-weight-600 text-white">{{ combine_buy_discount }}</div>
      </div>

      <div class="position-absolute bottom-0">
        <object class="align-bottom" :data="$baseUrl + 'img/svg/release_date_tag.svg'"></object>
        <div class="position-absolute top-2 pl-2 text-white">{{ !isEmpty(sale_date) ? formatSaleDate(sale_date) : '未定發售日' }}</div>
      </div>
      <div class="position-absolute bottom-3 right-3">
        <base-button class="rounded-5 opacity-8" style="" size="sm" type="darker" data-toggle="modal"
                     :data-target="'#'+selectorImage">
          <i class="text-main-color fa fa-search-plus fa-2x"></i>
        </base-button>
      </div>

    </div>


    <div class="mt-1"/>

    <div class="line-clamp-2 px-2">
      <TagItem :text="is_stock ? '庫存' :'預訂'" :color="is_stock ?'yellow':''"/>
      <span class="ml-1"/>
      {{ chinese_name }}
    </div>


    <div class="mt-1"/>

    <div class="d-flex grid-gap px-2">
      <TagItem v-if="isNew" :text="'最新'" :color="'yellow'" />
      <div v-for="(item, index) in tagList" :key="index">
        <TagItem :text="item.text" :color="item.color"></TagItem>
      </div>
    </div>

    <div class="mt-1"/>

    <div v-if="!isEmpty(note)" class="px-2 d-flex align-items-center">
      <span class="flex-shrink-0"><TagItem :text="'備註'" :color="'white'"/></span>
      <span class="ml-1"/>
      <span class="text-main-color font-size-16 line-clamp-1">{{ note }}</span>
    </div>

    <div v-if="isEmpty(note)" class="pt-4 line-clamp-1"/>


    <div class="mt-1"/>

    <div class="m-0 px-2 text-custom-gray-2" v-if="official_price > 0 && commodity_price_calc_type !== 'sell_price'">
      {{ formatMonetaryTypeName(official_monetary_type_id) }}原價
      <span class="text-through">{{
          formatMonetaryTypePrefix(official_monetary_type_id)
        }} {{ formatPrice(official_price) }}</span>
      {{ formatMonetaryTypeSuffix(official_monetary_type_id) }}
    </div>
    <!-- 原本用 h7（= font-size-base × 0.25，約 4px）小到幾乎看不清，改用一般小字級 -->
    <div class="m-0 px-2 font-size-13 text-custom-text-2 font-weight-600">
      {{ priceLabel() }}
    </div>
    <div class="m-0 px-2 text-custom-text-2 font-weight-600 h3">
      {{ formatPrice(price) }} <span class="font-weight-600 h6">元</span>
    </div>

    <div class="mt-1"/>

    <div v-if="is_orderable !== false && !(Catalog && Catalog.is_orderable === false)" class="px-2">
      <template v-if="isSaleOpen()">
        <base-button outline class="btn btn-lg w-100" type="main-color" data-toggle="modal"
                     :data-target="'#'+selectorOrder">訂購
        </base-button>
      </template>
      <template v-else>
        <base-button outline class="btn btn-lg w-100 disabled-order-btn" type="default" disabled aria-disabled="true" title="尚未開放下單">
          尚未開放下單
        </base-button>
      </template>
    </div>
    <div class="mt-1"/>

    <template v-if="isOrderCancelled">
      <!-- 被取消時也要看得到原訂數量，格式跟有調整數量時一致：先灰字「原下單 N」，再紅字提示 -->
      <div class="m-0 px-2 text-right">
        原下單 {{ buyAmount }} {{ this.unitType.text }}
      </div>
      <div class="m-0 px-2 text-right" style="color: #d9534f; font-weight: 600">
        此項訂購已由廠商取消
      </div>
    </template>
    <template v-else>
      <div v-if="additionAmount !== null" class="m-0 px-2 text-right">
        原下單 {{ buyAmount }} {{ this.unitType.text }}
      </div>
      <div class="m-0 px-2 text-main-color font-weight-600 text-right">
        {{ additionAmount !== null ? "由官方代訂為" : "已下單" }} {{
          additionAmount !== null ? additionAmount : buyAmount
        }} {{ this.unitType.text }}
      </div>
    </template>

    <div class="mt-1"/>

    <!-- 商品備註：門市開放才顯示；結單後（不可訂購）唯讀，沒有內容就不顯示 -->
    <div v-if="remarkEnabled && (isSaleOpen() || itemRemark)" class="px-2 item-remark">
      <TagItem :text="'商品備註'" :color="'white'"/>
      <textarea
        v-if="isSaleOpen()"
        v-model="itemRemark"
        class="form-control form-control-sm mt-1 item-remark-input"
        rows="2"
        maxlength="255"
        placeholder="商品備註（選填，最多 255 字）"
        @blur="saveRemark"
      ></textarea>
      <div v-else class="mt-1 item-remark-text">{{ itemRemark }}</div>
      <div v-if="isSaleOpen()" class="d-flex justify-content-between font-size-11 text-custom-gray-2">
        <span>{{ (itemRemark || '').length }} / 255</span>
        <span>{{ remarkSaving ? '儲存中...' : (remarkError ? '儲存失敗，請稍後再試' : (remarkSaved ? '已儲存' : '')) }}</span>
      </div>
    </div>

    <div class="mt-1"/>

    <div class="bg-custom-bg-color">
      <div class="row m-0 px-2 align-items-center">
        <TagItem :text="'Jan Code'" :color="'white'"/>
        <span class="ml-2"/>
        <div>{{ jan_code }}</div>
        <button class="btn no-hover btn-icon-only" @click="clickCopy(jan_code)">
          <i class="fa fa-clone"></i>
        </button>
      </div>

      <div class="row m-0  px-2 align-items-center">
        <TagItem :text="'貨號'" :color="'white'"/>
        <span class="ml-2"/>
        <div>{{ commodity_code }}</div>
        <button class="btn no-hover btn-icon-only" @click="clickCopy(commodity_code)">
          <i class="fa fa-clone"></i>
        </button>
      </div>
    </div>

    <div class="mt-1"/>


    <div v-if="is_combine_buy && is_orderable !== false && !(Catalog && Catalog.is_orderable === false)" class="row m-0 px-1 align-items-center">
      <div class="m-0 p-0 col-2" style="height: 24px">
        <label class="custom-toggle m-0 ">
          <input type="checkbox" v-model="isCombineBuy" :data-toggle="isCombineBuy ? '' : 'modal'"
                 data-target="#combineBuyHint">
          <span class="custom-toggle-slider rounded-circle"></span>
        </label>
      </div>

      <div v-if="!isCombineBuy " class="col-10">
        <span class="font-size-12">開啟湊箱 (湊箱成功可享{{ combine_buy_discount }}折扣)</span>
      </div>

      <div v-if="isCombineBuy" class="m-0 col-10">
        <span class="font-size-12"> 我可湊箱的數量 </span>
        <base-button class="m-0" size="sm" type="main-color" icon="fa fa-minus" @click="dec"/>
        <input
          type="number"
          class="px-1 quantity-input"
          v-model.number="combineBuyAmount"
          :step="unitType && unitType.unit_count ? unitType.unit_count : 1"
          :min="0"
          :max="Math.floor(999 / (unitType && unitType.unit_count ? unitType.unit_count : 1)) * (unitType && unitType.unit_count ? unitType.unit_count : 1)"
          inputmode="numeric"
          aria-label="調整湊箱數量"
          @input="onCombineBuyInput"
          @blur="onCombineBuyBlur"
          @keydown.enter.prevent="onCombineBuyEnter"
        />
        <base-button class="m-0" type="main-color" size="sm" icon="fa fa-plus" @click="add"/>
        <span class="font-size-12"> {{ this.unitType.text }} </span>
      </div>
    </div>

    <div v-if="is_stock" class="px-2">
      可下單數量 {{ stock }} PCS
    </div>


    <div class="mt-2"/>

    <Dialog
        :dataTarget="'combineBuyHint'"
        :title="'開啟湊箱'"
        :context="'開啟湊箱僅代表您同意商品參加湊箱，不代表商品湊箱成功，最終湊箱結果請於訂單管理查看。'"
        :confirmText="'我知道了'"
        onlyConfirm
    />

    <CommodityImageDialog
        :dataTarget="selectorImage"
        :title="chinese_name"
        :img_list="img_list"
    />

    <CommodityOrderDialog
        :dataTarget="selectorOrder"
        :commodity_id="id"
        :catalog_id="catalog_id"
        :title="chinese_name"
        :note="note"
        :img="img"
        :tag_list="tagList"
        :is_new="isNew"
        :is_stock="is_stock"
        :last_order_amount="last_order_amount"
        :commodity_price_calc_type="commodity_price_calc_type"
        :sell_monetary_type_id="sell_monetary_type_id"
        :sell_price="sell_price"
        :official_monetary_type_id="official_monetary_type_id"
        :official_price="official_price"
        :discount="discount"
        :is_combine_buy="isCombineBuy"
        :combine_buy_amount="combineBuyAmount"
        :combine_buy_discount="combine_buy_discount"
        :exchange_rate="exchangeRate"
        :unit_list="unitList"
        :unit_type="unitType"
        :amount="additionAmount !== null ? additionAmount : buyAmount"
        :additional_amount="additionAmount"
        @update="updatePrice"
    />

  </div>
</template>

<script>
import {clickCopy, generateUuidNo, imgIsEmpty, isEmpty} from '@/util/helpers';
import TagItem from "@/views/components/elements/TagItem"
import WatermarkImage from "@/components/WatermarkImage.vue";
import Dialog from "@/components/Dialog";
import CommodityImageDialog from "@/views/components/elements/CommodityImageDialog";
import CommodityOrderDialog from "@/views/components/elements/CommodityOrderDialog";
import * as formatter from "../../../util/formatter";
import EmptyImage from "@/components/EmptyImage.vue";
import {updateOrderCommodity} from "@/util/http_api";
import {checkError} from "@/util/error_handler";

export default {
  name: "CommodityItem",
  components: {
    EmptyImage,
    WatermarkImage,
    TagItem: TagItem,
    Dialog: Dialog,
    CommodityImageDialog: CommodityImageDialog,
    CommodityOrderDialog: CommodityOrderDialog,
  },
  props: {
    id: Number,
    catalog_id: Number,
    serial_id: {
      type: Number,
      default: 1,
    },
    is_stock: {
      type: Boolean,
      default: false,
    },
    chinese_name: {
      type: String,
      default: ''
    },
    note: {
      type: String,
      default: ''
    },
    sale_date: {
      type: String,
    },
    discount: {
      type: Number,
      default: 1,
    },
    commodity_price_calc_type: {
      type: String,
    },
    combine_buy_discount: {
      type: Number,
      default: 1,
    },
    sell_monetary_type_id: {
      type: Number,
      default: 0,
    },
    official_monetary_type_id: {
      type: Number,
      default: 0,
    },
    official_price: {
      type: Number,
      default: 0,
    },
    sell_price: {
      type: Number,
      default: 0,
    },
    // optional server-driven flag to indicate explicit orderable state
    orderable: {
      type: Boolean,
      default: undefined,
    },
    jan_code: {
      type: String,
      default: '',
    },
    commodity_code: {
      type: String,
      default: '',
    },
    is_orderable: {
      type: Boolean,
      default: true,
    },
    stock: {
      type: Number,
      default: 0,
    },
    last_order_amount: {
      type: Number,
      default: 0,
    },
    is_combine_buy: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    commodity_units: Object,
    PreOrderCommodity: Object,
    Catalog: Object,
    remark: String,
    OfficialMonetaryType: Object,
    CommodityBrand: Object,
    CommodityType: Object,
    Images: Array,
  },
  data() {
    return {
      selectorImage: "",
      selectorOrder: "",
      buyAmount: 0,
      additionAmount: null,
      isOrderCancelled: false,
      expectedPrice: 0,
      exchangeRate: 0,
      isCombineBuy: false,
      combineBuyAmount: 0,
      unitList: [],
      unitType: null,
      price: 0,
      tagList: [],
      img: {},
      img_list: [],
      itemRemark: this.remark || '',
      savedRemark: this.remark || '',
      remarkSaving: false,
      remarkSaved: false,
      remarkError: false,
    };
  },
  computed: {
    remarkEnabled() {
      const org = this.$store.state.myOrganization;
      return !!org && org.enable_item_remark === true;
    },
  },
  watch: {
    isCombineBuy(newValue) {
      // console.log('isCombineBuy : ', newValue);
      // if (newValue === false) this.combineBuyAmount = 0;
      this.updateCombineBuy();
    },
  },
  created() {
    const randomNum = generateUuidNo();
    this.selectorImage = `commodityImageDialog-${randomNum}`;
    this.selectorOrder = `commodityOrderDialog-${randomNum}`;
  },
  beforeMount() {
    this.initTag();
    this.initOrder();
    this.initUnitType();
    this.img_list = this.Images;
    if (this.img_list.length > 0) {
      this.img = this.img_list[0];
    }
    this.calculatePrice();
  },
  methods: {
    ceil: formatter.ceil,
    formatPrice: formatter.formatPrice,
    formatDateOnly: formatter.formatDateOnly,
    formatSaleDate: formatter.formatSaleDate,
    formatMonetaryTypeName: formatter.formatMonetaryTypeName,
    formatMonetaryTypePrefix: formatter.formatMonetaryTypePrefix,
    formatMonetaryTypeSuffix: formatter.formatMonetaryTypeSuffix,
    formatPriceCalculateType: formatter.formatPriceCalculateType,
    priceLabel() {
      if (this.commodity_price_calc_type === 'sell_price' || !(this.official_price > 0)) return '售價TWD';
      return this.commodity_price_calc_type === 'sale_price_discount' ? '售價折扣後TWD' : '匯率折扣後TWD';
    },
    isEmpty, imgIsEmpty,
    shouldShowDiscountTag(value) {
      if (value === null || value === undefined || value === '') return false;
      const num = Number(value);
      if (!isFinite(num)) return false;
      if (num <= 0) return false;
      const normalized = num > 1 ? num / 100 : num;
      return normalized !== 1;
    },
    formatDiscountDisplay(value) {
      const num = Number(value);
      if (!isFinite(num)) return value;
      const normalized = num > 1 ? num / 100 : num;
      const truncated = Math.trunc(normalized * 1000) / 1000;
      return truncated.toFixed(3).replace(/\.?0+$/, '');
    },
    initOrder() {
      if (this.PreOrderCommodity !== null && this.PreOrderCommodity !== undefined) {
        this.buyAmount = this.PreOrderCommodity.amount;
        this.additionAmount = this.PreOrderCommodity.additional_amount;
        this.isCombineBuy = this.PreOrderCommodity.is_combine_buy;
        this.combineBuyAmount = this.PreOrderCommodity.combine_buy_amount;
        // 廠商調整數量調成 0，且原本真的有下單，才算取消訂購（沒有獨立的訂單狀態）
        this.isOrderCancelled = (this.additionAmount === 0 && this.buyAmount > 0);
        // 調整後數量跟原下單數量一樣，等於沒有調整，不用顯示「由官方代訂為」
        if (!this.isOrderCancelled && (this.additionAmount === 0 || this.additionAmount === this.buyAmount)) {
          this.additionAmount = null;
        }
      }

      if (this.buyAmount === null || this.buyAmount === undefined) this.buyAmount = 0;
      if (this.isCombineBuy === null || this.isCombineBuy === undefined) this.isCombineBuy = false;
      if (this.combineBuyAmount === null || this.combineBuyAmount === undefined) this.combineBuyAmount = 0;
      this.exchangeRate = this.OfficialMonetaryType.exchange_rate;
    },
    initUnitType() {
      if (this.commodity_units !== null && this.commodity_units !== undefined) {
        let keys = Object.keys(this.commodity_units);
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          if (!key.endsWith('value')) continue;
          let [unit] = key.split('_');
          let unit_count = this.commodity_units[`${unit}_unit`];
          if (!unit_count) unit_count = 1;
          this.unitList.push({
            text: unit,
            amount: this.commodity_units[key],
            unit_count: unit_count,
          });
        }
      }
      if (this.unitList.length === 0) {
        this.unitList.push({
          text: 'PCS',
          amount: 1,
          unit_count: 1,
        });
      }
      this.unitType = this.unitList[0];
    },
    initTag() {
      this.tagList.push({text: this.CommodityBrand.name, color: 'blue'});
      this.tagList.push({text: this.CommodityType.name, color: 'green'});
    },
    calculatePrice() {
      // console.log('calculate price');
      const d = this.discount > 1 ? this.discount / 100 : this.discount;
      switch (this.commodity_price_calc_type) {
        case 'sale_price_discount':
          this.price = this.ceil(this.official_price * d, 2);
          break;
        case 'exchange_rate_discount':
          this.price = this.ceil(this.official_price * this.OfficialMonetaryType.exchange_rate * d, 2);
          break;
        case 'sell_price':
          this.price = this.sell_price;
          break;
      }
      if (this.isCombineBuy && this.combineBuyAmount > 0) {
        this.price = this.ceil(this.price * this.combine_buy_discount, 2);
      }
      this.expectedPrice = this.ceil(this.price * this.getAmount() * this.unitType.amount, 2);
      this.$emit('update', this.id, this.expectedPrice);
    },
    isSaleOpen() {
      // 0) Catalog.is_orderable 優先：型錄未開放則直接不可訂購
      if (this.Catalog && this.Catalog.is_orderable === false) {
        return false;
      }

      // Priority:
      // 1) explicit boolean prop `orderable`
      if (typeof this.orderable === 'boolean') {
        return this.orderable;
      }

      // 2) declared is_orderable prop
      if (typeof this.is_orderable === 'boolean') {
        return this.is_orderable;
      }

      // 3) check common server-side field names passed via v-bind (undeclared props end up in $attrs)
      const candidates = [
        'orderable', 'is_orderable', 'isOrderable',
        'order_open', 'is_order_open', 'isOrderOpen',
        'open_for_order', 'openForOrder',
        'can_order', 'canOrder',
        'available_for_order', 'availableForOrder',
        'orderable_flag', 'is_open',
        'status'
      ];
      try {
        for (let key of candidates) {
          if (Object.prototype.hasOwnProperty.call(this.$attrs, key)) {
            const val = this.$attrs[key];
            if (typeof val === 'boolean') {
              return val;
            }
            if (typeof val === 'number') {
              return val !== 0;
            }
            if (typeof val === 'string') {
              const lower = val.toLowerCase();
              // handle status-like strings (including localized '上架')
              if (key === 'status') {
                if (lower.indexOf('上架') !== -1 || lower.indexOf('published') !== -1 || lower.indexOf('online') !== -1 || lower.indexOf('active') !== -1) {
                  return true;
                }
                if (lower.indexOf('下架') !== -1 || lower.indexOf('draft') !== -1 || lower.indexOf('offline') !== -1) {
                  return false;
                }
              }
              if (lower === 'true' || lower === '1' || lower === 'yes') {
                return true;
              }
              if (lower === 'false' || lower === '0' || lower === 'no') {
                return false;
              }
            }
          }
        }
      } catch (e) {
        console.debug('isSaleOpen $attrs check error', e);
      }

      // default: not open
      return false;
    },
    getAmount() {
      if (this.additionAmount !== null) return this.additionAmount;
      return this.buyAmount;
    },
    updatePrice(operate_amount) {
      console.log('update amount ' + operate_amount);
      this.buyAmount = operate_amount;
      this.additionAmount = null;
      this.calculatePrice();
    },
    add() {
      this.processCount(1);
    },
    dec() {
      this.processCount(-1);
    },
    processCount(add) {
      let unit_count = this.unitType.unit_count;
      let count = Math.floor(this.combineBuyAmount / unit_count) + add;
      count = Math.min(Math.max(count, 0), Math.floor(999 / unit_count));
      this.combineBuyAmount = count * unit_count;
      this.updateCombineBuy();
    },
    async saveRemark() {
      const remark = (this.itemRemark || '').trim();
      this.itemRemark = remark;
      if (remark === this.savedRemark) return;
      this.remarkSaving = true;
      this.remarkSaved = false;
      this.remarkError = false;
      try {
        // 後端以 200 + status:'fail' 回傳錯誤（例如超過 255 字），要自己檢查，否則會被當成儲存成功
        const response = await updateOrderCommodity({
          catalog_id: this.catalog_id,
          commodity_id: this.id,
          remark: remark,
        });
        if (!checkError(null, response)) {
          this.remarkError = true;
          return;
        }
        this.savedRemark = remark;
        this.remarkSaved = true;
      } catch (e) {
        console.error(e);
        this.remarkError = true;
      } finally {
        this.remarkSaving = false;
      }
    },
    async updateCombineBuy() {
      await updateOrderCommodity({
        catalog_id: this.catalog_id,
        commodity_id: this.id,
        is_combine_buy: this.isCombineBuy,
        combine_buy_amount: this.combineBuyAmount,
      });
    },
    clickCopy(str) {
      clickCopy(str)
    },
    onCombineBuyInput(e) {
      this.normalizeCombineBuy();
      this.updateCombineBuy();
    },
    onCombineBuyBlur(e) {
      this.normalizeCombineBuy();
      this.updateCombineBuy();
    },
    onCombineBuyEnter(e) {
      this.normalizeCombineBuy();
      this.updateCombineBuy();
    },
    normalizeCombineBuy() {
      let val = Number(this.combineBuyAmount) || 0;
      const unit = (this.unitType && this.unitType.unit_count) ? this.unitType.unit_count : 1;
      const max = Math.floor(999 / unit) * unit;
      val = Math.max(0, Math.min(val, max));
      val = Math.floor(val / unit) * unit;
      this.combineBuyAmount = val;
    },
  }
}
</script>

<style scoped>
.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tag-color {
  color: #FFD58E;
}

.grid-gap {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 10px;
}

.imgSize {
  /*min-width: 130px;*/
  height: 220px;
  max-height: 220px;
}

.fit-contain {
  object-fit: contain;
}

.fit-fill {
  object-fit: fill;
}

.fit-cover {
  object-fit: cover;
}

.item-remark-input,
.item-remark-input:focus {
  resize: none;
  font-size: 14px;
  color: #000;
}

.item-remark-text {
  color: #000;
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 14px;
}

.quantity-input {
  max-width: 80px;
  padding: 0.2rem 0.4rem;
  background: transparent;
  border: 0;
  box-shadow: none;
  text-align: center;
  -moz-appearance: textfield;
}
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.quantity-input:focus {
  outline: none;
}

.disabled-order-btn {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
  box-shadow: none;
  background-color: #e9ecef;
  color: #6c757d;
  border-color: #ddd;
}

</style>
